import { organisationAPI } from '@/api';

/**************** STATE *******************/
const state = {
  map: null,
  /* Municipality format:
    insee: string
    displayName: string
  */
  municipalitiesList: [],
  searchedMunicipalities: [],
  selectedMunicipalities: []
};

/**************** GETTERS *****************/
const getters = {
  mapBounds(state) {
    if (state.map) {
      return state.map.getBounds();
    }
    return null;
  },
  areAllMunicipalitiesSelected(state) {
    return state.selectedMunicipalities.length === state.municipalitiesList.length;
  }
};

/*************** MUTATIONS ****************/
const mutations = {
  SET_MUNICIPALITIES_MAP: (state, payload) => {
    state.map = payload;
  },
  SET_MUNICIPALITIES_LIST: (state, payload) => {
    if (payload && payload.length) {
      state.municipalitiesList = [...payload.map(el => {
        return {
          insee: el.codename,
          displayName: el.display_name
        };
      })];
    } else {
      state.municipalitiesList = [];
    }
  },
  SET_SEARCHED_MUNICIPALITIES: (state, payload) => {
    if (payload && payload.length) {
      state.searchedMunicipalities = [...payload];
    } else {
      state.searchedMunicipalities = [];
    }
  },
  ADD_SELECTED_MUNICIPALITY: (state, payload) => {
    const index = state.selectedMunicipalities.findIndex(el => el.insee === payload.insee);
    if (index === -1) {
      state.selectedMunicipalities.push(payload);
    }
  },
  REMOVE_SELECTED_MUNICIPALITY: (state, payload) => {
    const index = state.selectedMunicipalities.findIndex(el => el.insee === payload.insee);
    if (index !== -1) {
      state.selectedMunicipalities.splice(index, 1);
    }
  },
  SET_ALL_SELECTED_MUNICIPALITIES: (state) => {
    state.selectedMunicipalities = [...state.municipalitiesList];
  },
  RESET_SELECTED_MUNICIPALITIES: (state) => {
    state.selectedMunicipalities = [];
  }
};
/**************** ACTIONS *****************/
const actions = {
  GET_MUNICIPALITIES: async ({ commit }) => {
    const municipalitiesList = await organisationAPI.getMunicipalities();
    commit('SET_MUNICIPALITIES_LIST', municipalitiesList);
  },
  SEARCH_MUNICIPALITIES: async ({ commit }, query) => {
    const searchedMunicipalities = await organisationAPI.searchMunicipalities(query);
    commit('SET_SEARCHED_MUNICIPALITIES', searchedMunicipalities);
  },
  SELECT_MUNICIPALITY: async ({ state, getters, commit }, municipality) => {
    const features = state.map.queryRenderedFeatures(getters.mapBounds, { layers: ['communes'] });
    const feature = features.find(el => el.id === municipality.insee);
    if (feature) {
      const src = {
        source: feature.source,
        sourceLayer: feature.sourceLayer,
        id: feature.id,
      };
      state.map.setFeatureState(src, {
        select: true,
      });
    }
    commit('ADD_SELECTED_MUNICIPALITY', municipality);
  },
  DESELECT_MUNICIPALITY: async ({ state, getters, commit }, municipality) => {
    const features = state.map.queryRenderedFeatures(getters.mapBounds, { layers: ['communes'] });
    const feature = features.find(el => el.id === municipality.insee);
    if (feature) {
      const src = {
        source: feature.source,
        sourceLayer: feature.sourceLayer,
        id: feature.id,
      };
      state.map.setFeatureState(src, {
        select: false,
      });
    }
    commit('REMOVE_SELECTED_MUNICIPALITY', municipality);
  },
  SELECT_ALL_MUNICIPALITIES: async ({ state, commit }) => {
    const features = state.map.queryRenderedFeatures(getters.mapBounds, { layers: ['communes'] });
    for (const feature of features) {
      const src = {
        source: feature.source,
        sourceLayer: feature.sourceLayer,
        id: feature.id,
      };
      state.map.setFeatureState(src, {
        select: true,
      });
    }
    commit('SET_ALL_SELECTED_MUNICIPALITIES');
  },
  DESELECT_ALL_MUNICIPALITIES: async ({ state, commit }) => {
    const features = state.map.queryRenderedFeatures(getters.mapBounds, { layers: ['communes'] });
    for (const feature of features) {
      const src = {
        source: feature.source,
        sourceLayer: feature.sourceLayer,
        id: feature.id,
      };
      state.map.setFeatureState(src, {
        select: false,
      });
    }
    commit('RESET_SELECTED_MUNICIPALITIES');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
